import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTeam,
  fetchTeamSuccess,
  fetchTeamFailure,
} from "../slices/teamSlice";

function* fetchTeamSaga() {
  try {
    const response = yield call(
      fetch,
      `${process.env.REACT_APP_API_URL}/employees/detalls`,
    );
    if (!response.ok) throw new Error(`API error: ${response.status}`);

    const result = yield response.json();
    yield put(fetchTeamSuccess(result.data || []));
  } catch (error) {
    yield put(fetchTeamFailure(error.message));
  }
}

export function* watchTeam() {
  yield takeLatest(fetchTeam.type, fetchTeamSaga);
}
